import '@babel/polyfill';
import 'mutationobserver-shim';
import 'fullpage.js/vendors/scrolloverflow';
// require styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'swiper/dist/css/swiper.css';
import './assets/fonts/font.css';

import Vue from 'vue';
// plugins
import BootstrapVue from 'bootstrap-vue';
import VueFullPage from 'vue-fullpage.js';
import BaiduMap from 'vue-baidu-map';
import VueAwesomeSwiper from 'vue-awesome-swiper';

import App from './App.vue';
import router from './router';
// import lazyLoad from "./directives/lazy";
import './api';

Vue.use(BootstrapVue)
Vue.use(VueFullPage);
Vue.use(BaiduMap, { ak: '' })
Vue.use(VueAwesomeSwiper, /* { default global options } */)

// Vue.use(lazyLoad, require('@/assets/loading.jpg'))

Vue.config.productionTip = false

// 全局方法-将文件名含中文的修改替换
Vue.prototype.$changeFileName = function(file) {
  const newBlob = new Blob([file], {type: file.type});
  // 创建一个新的 File 对象，使用新的文件名
  const newFile = new File([newBlob], file.name.toString().replaceAll(/[\u4e00-\u9fff]/g, 'e'), {
    type: file.type,
    lastModified: file.lastModified
  });

  return newFile;
}

router.beforeEach((to, from, next) => {
  //to即将进入的目标路由对象，from当前导航正要离开的路由， next  :  下一步执行的函数钩子

  // // 需要登录验证，并且还未登录
  // if (to.path != '/manager/login' && to.meta.requiresAuth && !localStorage.getItem('TOKEN')) { 
  //   next({ path: '/manager/login' });
  //   return; 
  // }
  if (to.matched.length === 0) { 
    from.name ? next({
      name: from.name
    }) : next('/'); 
  } else {
    next(); //如果匹配到正确跳转
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
